/**
 * Character key codes which can be used in keyboard events.
 */
export const KEY_UP = 'ArrowUp';
export const KEY_DOWN = 'ArrowDown';
export const KEY_HOME = 'Home';
export const KEY_END = 'End';
export const KEY_TAB = 'Tab';
export const KEY_ENTER = 'Enter';
export const KEY_SPACE = 'Space';
export const ESCAPE = 'Escape';